import React from "react";
import { Modal } from "react-rainbow-components";
import styled from "styled-components";
interface Props {
  titleConfirm?: string;
  titleCancle?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  isOpen: boolean;
  onRequestClose?: () => void;
  title?: string;
  description?: string;
}

export const Button = styled.div`
  cursor: pointer;
  padding: 0.5rem 2rem;
  border-radius: 999rem;
  background-color: #4779f4;
  color: #fff;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0 2rem;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  align-self: center;
`;

export const Description = styled.p`
  padding: 1rem;
`;

export const ModalConfirmation = (props: Props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      hideCloseButton
    >
      <Container>
        <Title>{props.title || "Title"}</Title>
        <Description className="text-h-color">
          {props.description || "Discription"}
        </Description>
        <ButtonContainer>
          <Button
            onClick={props.onCancel}
            style={{ backgroundColor: "#d54151" }}
          >
            ยกเลิก
          </Button>
          <Button onClick={props.onConfirm}>ยืนยัน</Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

export default ModalConfirmation;
